export {DialpadLogo} from './dialpad-logo';
